import { ObservableArray, View } from "binder"
import { lineItem, ReceiptWreckedProductViewModel } from "./receiptWreckedProduct-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ReceiptWreckedProductView extends View<ReceiptWreckedProductViewModel>{
    GetViewUniqueId(): string {
        return "V-54AFCCFA-F5EE-4C56-907F-176151F7431E"
    }
    loadHtml(): string {
        let element = require('./receiptWreckedProduct.html').default;
        let style = require('./receiptWreckedProduct.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set items(v: ObservableArray<lineItem>) { this._items = v; } public get items(): ObservableArray<lineItem> { return this._items;} private _items: ObservableArray<lineItem>;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  


}
